import { css } from 'styled-components';
import * as cons from '../../constants';
import * as colors from '../../colors';
export const FormCardStyle = css `
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 1px 0px ${cons.COLOR_GRAY_3};
  padding: 8px 18px 32px 18px;
  box-sizing: border-box;
  width: 100%;
  @media only screen and (min-width: 400px) {
    width: 350px;
  }
`;
export const LabelStyle = css `
  color: ${cons.COLOR_GRAY_3};
  font-weight: 700;
  text-transform: uppercase;
  font-size: 12px;
  margin-top: 20px;
  margin-bottom: 8px;
`;
export const AccountForm = css `
  border-radius: 4px;
  background-color: #efefef;
  font-size: 16px;
  padding: 12px 10px;
  box-shadow: none;
  border: none;
  &::placeholder {
    color: ${colors.BLACK_7};
  }
  color: ${colors.FONT_SECONDARY};

  width: 100%;
  box-sizing: border-box;
`;
export const SwitchPage = css `
  margin-top: 24px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  & button {
    color: white;
    /* opacity: 0.8; */
  }
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
export const ErrorMessageStyle = css `
  color: hsl(357deg 84% 70%);
  border-radius: 8px;
  margin-top: 12px;
  margin-bottom: -12px;
  font-weight: 400;
  text-align: center;
  font-size: 14px;
`;
